// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const { user, loading } = useContext(AuthContext);
  console.log(user);
  
  if (loading) {
    // Możesz zwrócić loader lub nic nie renderować, aż dane zostaną pobrane
    return <div>Ładowanie...</div>;
  }

  return user ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
